module.exports = __webpack_public_path__ + "img/right.10c4614f.svg";